import { GET, POST, PUT, DELETE } from './core';
import getEnv from '../../env';

const BASE = getEnv('REACT_APP_MERCHANT_PORTAL_API');

export const getAllRewardRules = (token) =>
  GET('/reward-rule', token);

export const getRewardRuleById = (id, token) =>
  GET(`/reward-rule/${id}`, token);

export const createRewardRule = (payload, token) =>
  POST('/reward-rule/create', payload, token);

export const updateRewardRule = (payload, token) =>
  PUT('/reward-rule/update', payload, token);

export const deleteRewardRule = (id, token) =>
  DELETE(`/reward-rule/delete/${id}`, {}, token);

export const toggleRewardRule = (id, token) =>
  fetch(`${BASE}/v1.0/app/reward-rule/toggle/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }).then(async (r) => {
    const d = await r.json();
    if (r.status >= 400) throw d;
    return d;
  });
